import LessonOverviewModalContainer from '../../../containers/LessonsPage/LessonOverviewModalContainer';
import TrackOverviewModalContainer from '../../../containers/TracksPage/TrackOverviewModalContainer';
import { ShortOverviewModal } from '../../overview';
import { NextPlaylistContent } from './NextPlaylistContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const NextPlaylistContentOverview = ({
  trackId,
  lessonId,
  shortId,
  language
}) => {
  return /*#__PURE__*/_jsx(NextPlaylistContent, {
    language: language,
    lessonId: lessonId,
    render: ({
      trackId: nextTrackId,
      lessonId: nextLessonId,
      shortId: nextShortId,
      language: nextItemLanguage
    }) => {
      if (nextShortId) {
        return /*#__PURE__*/_jsx(ShortOverviewModal, {
          allowFullWidthChildren: true,
          language: nextItemLanguage,
          shortId: nextShortId
        });
      } else if (nextTrackId) {
        return /*#__PURE__*/_jsx(TrackOverviewModalContainer, {
          allowFullWidthChildren: true,
          language: nextItemLanguage,
          trackId: nextTrackId
        });
      } else if (nextLessonId) {
        return /*#__PURE__*/_jsx(LessonOverviewModalContainer, {
          allowFullWidthChildren: true,
          language: nextItemLanguage,
          lessonId: nextLessonId
        });
      }
      return null;
    },
    shortId: shortId,
    trackId: trackId
  });
};